import { NodeModel } from "../_model/NodeModel";
import { DecorationArrow } from "./decorationArrow"
import { Types } from "../../utils/nodeTypes"
import { COLORS } from "../../utils/colors";

class Arrow extends NodeModel {
  constructor() {
    super("Arrow");
    
    this.type = new Types().Arrow;
    this.x = 0;
    this.y = 0;
    this.dif = 100
    this.height = 50;
    this.width = 110;
    this.direction = "rigth"
    this.arrowChanged = false
    
    // Line
    this.stroke = 5
    this.color = COLORS.RoyalBlue
    
    // Triangle
    this.size = 250;
    this.rotate = 90;
    this.directionArrowX = 100
    this.directionArrowY = 0
    this.path = `M${this.x},${this.y}L${this.directionArrowX},${ this.directionArrowY }`

    this.data = []
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationArrow();
      await this.decorator.init(this,callback)
    };

    this.clone = () => {
      let cloned = new Arrow
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.readOnly = this.readOnly
      cloned.height = this.height
      cloned.width = this.width
      cloned.stroke = this.stroke;
      cloned.lineX = this.lineX;
      cloned.lineY = this.lineY;
      cloned.color = this.color;
      cloned.size = this.size ;
      cloned.dif = this.dif;
      cloned.rotate = this.rotate;
      cloned.direction = this.direction
      cloned.directionArrowX = this.directionArrowX;
      cloned.directionArrowY = this.directionArrowY;
      cloned.decorator = null
      cloned.expressionVisible = this.expressionVisible;

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.height = node.height
      this.width = node.width
      this.stroke = node.stroke;
      this.lineX = node.lineX
      this.lineY = node.lineY
      this.color = node.color;
      this.size = node.size ;
      this.dif = node.dif;
      this.rotate = node.rotate;
      this.direction = node.direction
      this.directionArrowX = node.directionArrowX;
      this.directionArrowY = node.directionArrowY;
    }

    this.update = (nodeEdited) => {
      this.direction = nodeEdited.direction
      this.directionArrowX = nodeEdited.directionArrowX
      this.directionArrowY = nodeEdited.directionArrowY
      this.size = nodeEdited.size
      this.rotate = nodeEdited.rotate
      this.lineX = nodeEdited.lineX
      this.lineY = nodeEdited.lineY
      this.color = nodeEdited.color
      this.stroke = nodeEdited.stroke;
      this.dif = nodeEdited.dif;
      this.expressionVisible = nodeEdited.expressionVisible

      this.decorator.update();
    }

    this.setDirection = function(direction) {
      this.direction = direction
      this.arrowChanged = true      
      this.setLineXY1()

      if(direction == "left"){
        this.rotate = 270
        this.chageLying(true)
      }

      if(direction == "down"){
        this.rotate = 180
        this.chageLying(false)
      }

      if(direction == "rigth"){
        this.rotate = 90
        this.chageLying(true)
      }

      if(direction == "up"){
        this.rotate = 0
        this.chageLying(false)
      }
    },

    this.chageLying = function(isLying){
      if(isLying && this.height > this.width || !isLying && this.width > this.height){
        let aux = this.height
        this.height = this.width
        this.width = aux
      }
    }

    this.pathLine = function () {
        if(this.direction == "rigth")
          this.path = `M${ this.x },${ this.y }L${ this.x + this.dif},${ this.y }` // ok

        if(this.direction == "down")
          this.path = `M${ this.x },${ this.y }L${ this.x },${ this.y + this.dif }`
        
        if(this.direction == "left") 
          this.path = `M${ this.x - this.dif },${ this.y }L${ this.x },${ this.y }`

        if(this.direction == "up")
          this.path = `M${ this.x },${ this.y - this.dif }L${ this.x },${ this.y }`

      return this.path
    }

    this.xArrow = function () { 
      if(this.direction == "rigth")
        return this.x + this.dif

      if(this.direction == "down")
        return this.x
      
      if(this.direction == "left") 
        return this.x - this.dif
      
      if(this.direction == "up")
        return this.x
    }

    this.yArrow = function () { 
      if(this.direction == "rigth")
        return this.y

      if(this.direction == "down")
        return this.y + this.dif
      
      if(this.direction == "left") 
        return this.y
      
      if(this.direction == "up")
        return this.y - this.dif
    }

    this.setLineXY1 = function(){
      if(this.direction == "rigth"){ // ok
        this.directionArrowX = this.x + this.dif
        this.directionArrowY = this.y
      }
      
      if(this.direction == "down"){ // ok
        this.directionArrowX = this.x
        this.directionArrowY = this.y + this.dif
      }
      
      if(this.direction == "left"){
        this.directionArrowX = this.x - this.dif
        this.directionArrowY = this.y
      } 

      if(this.direction == "up"){
        this.directionArrowX = this.x
        this.directionArrowY = this.y - this.dif
      }
    }

    this.setDif = function (){
      if(this.direction == "left") // ok
        this.dif = this.x - this.directionArrowX
      else if(this.direction == "rigth") // ok
        this.dif = this.directionArrowX - this.x
      else if(this.direction == "up") // ok
        this.dif = this.y - this.directionArrowY
      else if(this.direction == "down") // ok
        this.dif = this.directionArrowY - this.y

      if(this.height > this.width)
        this.height = this.dif + 5

      if(this.width > this.height)
        this.width = this.dif + 5
    }

    this.pathLineByResize = function () {
      if(this.direction == "rigth")
        this.path = `M${ this.x },${ this.y }L${ this.x + this.dif},${ this.y }` // ok
        
      if(this.direction == "down")
        this.path = `M${ this.x },${ this.y }L${this.x},${ this.y + this.dif }` // ok
      
      if(this.direction == "left") 
        this.path = `M${ this.x - this.dif},${ this.y}L${this.x},${this.y}` // ok
        
      if(this.direction == "up")
          this.path = `M${ this.x },${ this.y }L${ this.x },${this.y + this.dif}` //Ok

      return this.path
    }

    this.setDifInDrag = function (event) {
      if(this.direction == "left"){
        this.x = event.x < this.directionArrowX ? this.directionArrowX + 10 : event.x;
        this.dif = this.x - this.directionArrowX
      }

      if(this.direction == "rigth"){
        this.x = event.x > this.directionArrowX ? this.directionArrowX - 10 : event.x;
        this.dif = this.directionArrowX - this.x
      }

      if(this.direction == "down"){
        this.y = event.y > this.directionArrowY ? this.directionArrowY - 10 : event.y;
        this.dif = this.directionArrowY - this.y
      }

      if(this.direction == "up"){
        this.y = event.y < this.directionArrowY ? this.directionArrowY + 10 : event.y;
        this.dif = this.directionArrowY - this.y
      }
    }
  }
}

export { Arrow };
